import type { PageBridge, PageRequest } from './pageBridge';

export class PageDelivery {
  private results = new Map<string, { expiresAt: number; result: ReturnType<PageBridge['execute']> }>();

  async deliver(bridge: PageBridge, request: PageRequest) {
    const matches = bridge.connectionId === request.connectionId && bridge.pageId === request.pageId;
    if (request.operation === 'cancel') {
      if (matches) await bridge.execute(request);
      return;
    }
    for (const [id, entry] of this.results) {
      if (entry.expiresAt < Date.now()) this.results.delete(id);
    }
    let entry = this.results.get(request.requestId);
    if (!entry) {
      if (this.results.size >= 100) throw new Error('Too many pending page requests.');
      entry = {
        expiresAt: request.expiresAt + 60000,
        result: matches
          ? bridge.execute(request)
          : Promise.resolve({
              status: 'rejected',
              applied: false,
              code: 'stale_target',
              error: 'The active page changed. Read the current page before editing.',
            }),
      };
      this.results.set(request.requestId, entry);
    }
    const result = await entry.result;
    for (let attempt = 0; attempt < 3; attempt += 1) {
      try {
        await bridge.reply?.({ requestId: request.requestId, connectionId: request.connectionId, result });
        return;
      } catch (error) {
        if (attempt === 2 || Date.now() >= request.expiresAt) throw error;
        await new Promise((resolve) => setTimeout(resolve, 250 * (attempt + 1)));
      }
    }
  }
}
